export default function () {
  return {
    settings: [],
  }
}
